import {IBounds, Ic} from "./common";
import {ISingleOutput, ISpec} from "./ISpec";
import {numberToJson, Utils} from "../common/utils";
import {ValueFormatter} from "../common/ValueFormatter";
import {siPrefix} from "../common/siPrefix";

/**
 * Created by claudio iozzia on 05/05/2017.
 */
export function roundToEffectiveValue(val: number, perc: number, precision: number = 1): number {

  return ValueFormatter.scale((val * (1 + perc) * Math.SQRT2), siPrefix.unit, precision);
}

export function minPFCVout(maxInput: number, perc: number): number {

  const voutMin = roundToEffectiveValue(maxInput, perc, 1); // Carmelo dice: Valore efficace con tolleranza
  return Math.round(voutMin / 10) * 10;

}

export function currentBoundFromPower(ic: Ic, out: ISingleOutput<number>): IBounds {

  const minPower: number = Utils.getFieldValue(ic, "validator.power.min", NaN);
  const maxPower: number = Utils.getFieldValue(ic, "validator.power.max", NaN);

  const minVout: number = Utils.getNumberDefaultable(out.voltage, ic.vout_min);
  const maxVout: number = Utils.getNumberDefaultable(out.voltage, ic.vout_max);

  const minIout: number = ValueFormatter.scale((minPower / maxVout), siPrefix.unit, 2);
  const maxIout: number = ValueFormatter.scale((maxPower / minVout), siPrefix.unit, 2);

  return {min: minIout, max: maxIout};
}

/*
* This function is compatible with the old Console... for this reason the msg.data.specs has this format
* if change this structure need to change also widget parse function
* */
export function getContextAndParamUrl(context: string, specs: ISpec<number>, textSearched?: string, selectedKey?: string) {
  const params = new URLSearchParams();
  const setParamIfValid = (param, val) => val ? params.set(param, val) : void 0;

  setParamIfValid('context', context);
  if (specs) {
    setParamIfValid('msg.data.specs.input.v.min', numberToJson(specs.input.min));
    setParamIfValid('msg.data.specs.input.v.max', numberToJson(specs.input.max));
    setParamIfValid('msg.data.specs.input.f', numberToJson(specs.input.freq));

    if (context.startsWith('led')) {
      setParamIfValid('msg.data.specs.led.VF', numberToJson(specs.output.outputs[0].voltage));
      setParamIfValid('msg.data.specs.led.IF', numberToJson(specs.output.outputs[0].current));
      setParamIfValid('msg.data.specs.led.Rd', numberToJson(specs.output.ledParam.rd));
      setParamIfValid('msg.data.specs.numLed.serie', numberToJson(specs.output.ledParam.serial));

      if (context === 'led_dcdc') {
        setParamIfValid('msg.data.specs.numLed.parallel', numberToJson(specs.output.ledParam.parallel));
      }
    } else {
      specs.output.outputs.forEach((x, i) => {
        setParamIfValid('msg.data.specs.output.' + i + '.v', numberToJson(x.voltage));
        setParamIfValid('msg.data.specs.output.' + i + '.i', numberToJson(x.current));

      });
    }
  }

  setParamIfValid('msg.data.specs.rpn', textSearched);
  setParamIfValid('selected', selectedKey);

  // p.set('referrerPage', 'content/st.com/en/'+this.appInfo.name+'/html5' );
  return params.toString();
}
